/* build/tpl */
import deps from './deps/eachDeep.js';
import getEachDeep from './getEachDeep.js';
export default getEachDeep(deps);
